import { adDetector } from "../helpers/zones/ad_detector"
import { renderAdnimation } from "../helpers/zones/adnimation"
import { renderOutbrain } from "../helpers/zones/outbrain"
import { renderFiverr } from "../helpers/zones/fiverr"
import { renderCarbon, renderCarbonAuto } from "../helpers/zones/carbon"
import { hideHidden, showFallback, clear } from "../helpers/zones/zones"

const renderAds = () => {
  renderAdnimation()
  renderOutbrain()
  renderFiverr()
  renderCarbon()
}

const renderNoAds = () => {
  renderCarbonAuto()
  hideHidden()
  showFallback()
}

document.addEventListener("turbo:load", () => {
  adDetector(renderAds, renderNoAds)
})

document.addEventListener("turbo:before-cache", clear)
